<template>
  <sui-page>
    <sui-page-header title="Title"></sui-page-header>
    <sui-page-contents>
      <div class="comm_title_wrap">
        <h4>타이틀만 있는 경우</h4>
      </div>
      <!-- <pre>
         <code>
         &lt;div class="comm_title_wrap"&gt;
           &lt;h4&gt;타이틀만 있는 경우&lt;/h4&gt;
         &lt;/div&gt;
      </code>
    </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <span class="sui-input-label__star"></span>
        <h4>타이틀+인포메시지</h4>
        <div class="btn_wrap">
          <div class="info">CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min</div>
        </div>
      </div>
      <!-- <pre>
         <code>
         &lt;div class="comm_title_wrap"&gt;
           &lt;span class="sui-input-label__star"&gt;&lt;/span&gt;&lt;h4&gt;타이틀+인포메시지&lt;/h4&gt;
           &lt;div class="info"&gt;CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min&lt;/div&gt;
         &lt;/div&gt;
      </code>
    </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>타이틀+체크박스+버튼</h4>
        <div class="comm_line_div"></div>
        <sui-checkbox :checked="true" :disabled="false">Checkbox Content</sui-checkbox>

        <div class="btn_wrap">
          <button type="button" class="comm_sbtn_border">복사하기</button>
        </div>
      </div>
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>타이틀+셀렉트박스+버튼</h4>
        <div class="btn_wrap dp_inflex">
        <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
        >
        </sui-select-box>
          <button type="button" class="comm_sbtn_border">복사하기</button>
        </div>
      </div>
      <!-- <pre>
         <code>
           &lt;div class="comm_title_wrap"&gt;
             &lt;h4>타이틀+셀렉트박스+버튼&lt;/h4&gt;
             &lt;div class="btn_wrap dp_inflex"&gt;
             &lt;sui-select :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox"
             &gt;
             &lt;/sui-select&gt;
               &lt;button type="button" class="comm_sbtn_border"&gt;복사하기&lt;/button&gt;
             &lt;/div&gt;
           &lt;/div&gt;
      </code>
    </pre> -->
    <div class="mrB50"></div>
    <div class="comm_title_wrap">
      <h4>타이틀+체크박스+인포메시지+버튼</h4>
      <div class="comm_line_div"></div>
      <sui-checkbox :checked="true" :disabled="false">Checkbox Content</sui-checkbox>
      <div class="btn_wrap">
        <div class="info">CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min</div>
        <div class="comm_line_div"></div>
        <button type="button" class="comm_btn_gridTop comm_ico_excel">엑셀 다운로드</button>
      </div>
    </div>
    <!-- <pre>
       <code>
          &lt;div class="comm_title_wrap"&gt;
            &lt;h4>타이틀+체크박스+인포메시지+버튼 &lt;/h4&gt;
            &lt;div class="comm_line_div"&gt; &lt;/div&gt;
            &lt;fdp-checkbox :checked="true" :disabled="false">Checkbox Content &lt;/fdp-checkbox&gt;
            &lt;div class="btn_wrap"&gt;
              &lt;div class="info"&gt;CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min &lt;/div&gt;
              &lt;div class="comm_line_div"&gt; &lt;/div&gt;
              &lt;button type="button" class="comm_btn_gridTop comm_ico_excel"&gt;엑셀 다운로드 &lt;/button&gt;
            &lt;/div&gt;
          &lt;/div&gt;
    </code>
    </pre> -->
    <div class="mrB50"></div>
    <div class="comm_title_wrap">
      <h4>타이틀+인포메시지+텍스트버튼</h4>
      <div class="comm_line_div"></div>
      <div class="info">여기에도 인포메시지가 올 수 있음</div>
      <div class="btn_wrap">
        <div class="info">CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min</div>
        <div class="comm_line_div"></div>
        <button type="button" class="btn_txt_BL_arrow">자세히보기</button>
      </div>
    </div>
    <!-- <pre>
       <code>
          &lt;div class="comm_title_wrap"&gt;
            &lt;h4>타이틀+체크박스+인포메시지+버튼 &lt;/h4&gt;
            &lt;div class="comm_line_div"&gt; &lt;/div&gt;
            &lt;div class="info"&gt;여기에도 인포메시지가 올 수 있음&lt;/div&gt;
            &lt;fdp-checkbox :checked="true" :disabled="false">Checkbox Content &lt;/fdp-checkbox&gt;
            &lt;div class="btn_wrap"&gt;
              &lt;div class="info"&gt;CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min &lt;/div&gt;
              &lt;div class="comm_line_div"&gt; &lt;/div&gt;
              &lt;button type="button" class="comm_btn_gridTop comm_ico_excel"&gt;엑셀 다운로드 &lt;/button&gt;
            &lt;/div&gt;
          &lt;/div&gt;
    </code>
    </pre> -->
    <div class="mrB50"></div>
    <div class="comm_ptitle_wrap">
      <h1>패널스타일 타이틀</h1>
      <div class="comm_line_div"></div>
      <div class="info">여기에도 인포메시지가 올 수 있음</div>
    </div>
    <div class="mrB10"></div>
    <!-- <pre>
       <code>
         &lt;div class="comm_ptitle_wrap"&gt;
           &lt;h1>패널스타일 타이틀&lt;/h1&gt;
           &lt;div class="comm_line_div"&gt;&lt;/div&gt;
           &lt;div class="info">여기에도 인포메시지가 올 수 있음&lt;/div&gt;
         &lt;/div&gt;
    </code>
    </pre> -->
    <div class="mrB50"></div>
    <div class="comm_ptitle_wrap_required">
      <span class="required-icon"/>
      <h1>패널스타일 타이틀</h1>
      <div class="comm_line_div"></div>
      <div class="info">필수항목 표시</div>
    </div>
    <div class="mrB10"></div>
    <!-- <pre>
       <code>
          &lt;div class="comm_ptitle_wrap_required"&gt;
            &lt;span class="required-icon"/&gt;
            &lt;h1>패널스타일 타이틀 &lt;/h1&gt;
            &lt;div class="comm_line_div"&gt; &lt;/div&gt;
            &lt;div class="info"&gt;필수항목 표시 &lt;/div&gt;
          &lt;/div&gt;
    </code>
    </pre> -->
    <div class="mrB50"></div>
    <div class="comm_ptitle_wrap">
      <h1>패널스타일 타이틀+검정박스</h1>
      <div class="comm_line_div"></div>
      <div class="info">여기에도 인포메시지가 올 수 있음</div>
    </div>
    <div class="ptitle_box_black">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="셀렉트+텍스트필드텍스트필드텍스트필드텍스트필드" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-text-field placeholder="Input text" default value :disabled="false" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드" :required="false" :vertical="false"></sui-input-label>

          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value :disabled="false" :readonly="false"></sui-text-field>

          </div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋" :required="false" :vertical="false"></sui-input-label>

          </div>
          <div class="col-xs-3">
            <cmp-user-select :selectedUser="selectedUser" @selected="onSelectedUser" />
            </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="Datepicker" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="월달력" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
        </div>


      </div>
    </div>
    <div class="mrB10"></div>
    <!-- <pre>
       <code>
         &lt;div class="comm_ptitle_wrap"&gt;
           &lt;h1>패널스타일 타이틀+검정박스&lt;/h1&gt;
           &lt;div class="comm_line_div">&lt;/div&gt;
           &lt;div class="info"&gt;여기에도 인포메시지가 올 수 있음&lt;/div&gt;
         &lt;/div&gt;
         &lt;div class="ptitle_box_black"&gt;
           .........................
         &lt;/div&gt;
    </code>
    </pre> -->
    <div class="mrB50"></div>

    <div class="comm_ptitle_red_wrap">
      <h1>패널스타일 타이틀+빨강박스</h1>
      <div class="comm_line_div"></div>
      <div class="info">여기에도 인포메시지가 올 수 있음</div>
    </div>
    <div class="ptitle_box_red">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="셀렉트+텍스트필드텍스트필드텍스트필드텍스트필드" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-text-field placeholder="Input text" default value :disabled="false" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드텍스트필드" :required="false" :vertical="false"></sui-input-label>

          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value :disabled="false" :readonly="false"></sui-text-field>

          </div>
          <div class="col-xs-1">
            <sui-input-label label="서치인풋" :required="false" :vertical="false"></sui-input-label>

          </div>
          <div class="col-xs-3">
            <cmp-user-select :selectedUser="selectedUser" @selected="onSelectedUser" />
            </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="Datepicker" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="월달력" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="셀렉트박스" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
          </div>
        </div>


      </div>
    </div>
    <div class="mrB10"></div>
    <!-- <pre>
       <code>
         &lt;div class="comm_ptitle_red_wrap"&gt;
           &lt;h1>패널스타일 타이틀+빨강박스&lt;/h1&gt;
           &lt;div class="comm_line_div">&lt;/div&gt;
           &lt;div class="info"&gt;여기에도 인포메시지가 올 수 있음&lt;/div&gt;
         &lt;/div&gt;
         &lt;div class="ptitle_box_red"&gt;
           .........................
         &lt;/div&gt;
    </code>
    </pre> -->



    </sui-page-contents>
  </sui-page>
</template>
<script>
  /*global http*/
  export default {
    name: 'comp_title',
    data() {
      return {
      };
    },
    computed: {},
    watch: {},
    datasets: [],
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {},
  };
</script>
<style scoped>
  pre {
    background-color: #282C34;
    border: 1px solid #e4e4e4
  }
  code {
    font-family: AppleSDGothicNeo-Regular, "NanumGothic", dotum, "돋움체", sans-serif;
    font-size: 14px;
    color: #C8EBFA;
    line-height: 150%;
  }

</style>
